import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import classes from './UserInfoNoAccess.module.css';

const UserInfoNoAccess = props => {
  const { t } = useTranslation(['access']);
  const myDate = new Date(props.dataUser.systemDate);

  return (
    <>
      <p className={classes.infoTitle}>{t('title')}</p>
      <aside className={classes.userInfoNoAccessContainer}>
        <p className={classes.item}>
          {t('name')}:{' '}
          <span className={classes.infoData}>
            {props.dataUser.apellido}
          </span>
        </p>
        <p className={classes.item}>
          {t('email')}:{' '}
          <span className={classes.infoData}>
            {props.dataUser.email}
          </span>
        </p>
        <p className={classes.item}>
          {myDate.toDateString()} {myDate.toLocaleTimeString()}
        </p>
        <p className={classes.itemUserName}>
          {t('welcome')} {props.dataUser.nombre}!
        </p>
      </aside>
      <p className={classes.descriptionText}>{t('initial_text')}</p>
    </>
  );
};

UserInfoNoAccess.propTypes = {
  // eslint-disable-next-line react/require-default-props
  dataUser: PropTypes.object
};

export default UserInfoNoAccess;
